import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import MainPanel from "./Component/MainPanel";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {[
            "/",
            "/home",
            "/shortVideo",
            "/watchHistory",
            "/myList",
            "/activateTV",
            "/myAccount",
            "/help",
            "/notification",
            "/search",
            "/categories",
          ].map((path) => (
            <Route
              key={path}
              path={path}
              element={
                path === "/" ||
                path === "/home" ||
                path === "/shortVideo" ||
                path === "/watchHistory" ||
                path === "/myList" ||
                path === "/activateTV" ||
                path === "/myAccount" ||
                path === "/help" ||
                path === "/notification" ||
                path === "/search" ||
                path === "/categories" ? (
                  <MainPanel path={path} />
                ) : (
                  "/home"
                )
              }
            />
          ))}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
